var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:_vm.listLinkClasses,style:(_vm.linkStyles)},[_c('div',{staticClass:"list-link__value"},[_vm._v("\n        "+_vm._s(_vm.trend === 0 ? '' : _vm.trend > 0 ? ("+" + _vm.trend) : _vm.trend)+"\n    ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }